
import { Vue, Options } from "vue-class-component";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import { HistoryFollowUpOutgoing, ActivitiesFollowUpOutgoing, HistoryFollowUpOutgoingFilterRequest } from '@/domain/entities/HangingOutgoing';
import { debounce } from "lodash";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import { Pagination } from "@/domain/entities/Pagination";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import moment from "moment";

@Options({
  components: {
    PaginationV3,
  }
})

class TabRiwayatFollowUpOutgoing extends Vue {
  isLoading = false;
  errorState = "";
  filterDate = new Date();
  filter = new HistoryFollowUpOutgoingFilterRequest();
  historyFollowUpOutgoing: HistoryFollowUpOutgoing[] = [];
  pagination = new Pagination(1, 10)
  maxDate = new Date();

  get renderedData() {
    return this.historyFollowUpOutgoing.flatMap((obj) => obj.activities).length;
  }

  setDateRange([startDate, endDate]: string[]) {
    this.filter = new HistoryFollowUpOutgoingFilterRequest({
      ...this.filter,
      page: 1,
      startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
      endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : ""
    });
    startDate && endDate && this.getFilter(this.filter);
  }

  get activityType() {
    return [
      { name: this.$t("dashboard.hanging.allActivities"), value: "" },
      { name: this.$t("dashboard.hanging.followUpOps"), value: "follow_up_ops" },
      { name: this.$t("dashboard.hanging.searchSttWarehouse"), value: "follow_up_warehouse" }
    ];
  }

  activityTypeSelect = false;
  onOpenActivityType(value: boolean) {
    this.activityTypeSelect = value;
  }

  onSelectActivityType(_: string, value: string) {
    this.filter.activityType = value;
    this.filter.page = 1;
    this.onOpenActivityType(false);
    this.getFilter(this.filter);
  }

  async mounted() {
    await this.getHistoryFollowUpOutgoing(new HistoryFollowUpOutgoingFilterRequest());
  }

  getFilter = debounce((filter: Partial<HistoryFollowUpOutgoingFilterRequest>) => {
    this.filter = new HistoryFollowUpOutgoingFilterRequest(filter);
    this.getHistoryFollowUpOutgoing(this.filter);
  }, 250);

  async getHistoryFollowUpOutgoing(params: HistoryFollowUpOutgoingFilterRequest) {
    try {
      this.errorState = "";
      this.isLoading = true;
      const res = await SttHangingController.getHistoryFollowUpOutgoing(params);
      this.historyFollowUpOutgoing = res.data;
      this.pagination = res.pagination
    } catch (err) {
      this.errorState = err.response ? "server" : "internet";
    } finally {
      this.isLoading = false;
    }
  }

  async toPage(page: number) {
    if (page === this.pagination.page) {
      return;
    }
    this.pagination.page = page;
    this.filter = new HistoryFollowUpOutgoingFilterRequest({
      ...this.filter,
      page: page
    });
    await this.getHistoryFollowUpOutgoing(this.filter);
  }

  mapActivityType(activitie: ActivitiesFollowUpOutgoing) {
    const label: any = {
      "follow_up_ops": `${this.$t("dashboard.hanging.followUpOps")} ${activitie.followUp?.opsUsername}`,
      "follow_up_warehouse": this.$t("dashboard.hanging.searchSttWarehouse"),
    }

    const icon: any = {
      "follow_up_ops": "ic_pic",
      "follow_up_warehouse": "ic_search_hanging"
    }

    return {
      label: label[activitie.activityType] ?? "-",
      icon: icon[activitie.activityType] ?? "ic_pic"
    }
  }

  formatDateToString(date: string) {
    return formatDate(date);
  }
}
export default TabRiwayatFollowUpOutgoing;
